import type { ReactNode } from 'react';

import * as Styled from './StepLayout.styled';

type StepLayoutProps = {
  title: string;
  children: ReactNode;
  currentStep: number;
  totalSteps: number;
};

const StepLayout = ({
  title,
  children,
  currentStep,
  totalSteps,
}: StepLayoutProps) => {
  return (
    <div>
      <Styled.Header>
        <Styled.Title>{title}</Styled.Title>
        <Styled.StepCounter>
          Step {currentStep}/{totalSteps}
        </Styled.StepCounter>
      </Styled.Header>
      {children}
    </div>
  );
};

export { StepLayout };
